module.exports = __webpack_public_path__ + "img/elraghi.4790c752.png";